// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Button} from '../../../button/Button'
import {Icon} from '../../../icon/Icon'

@Component({
    components: {
        Button,
        Icon,
    },
    mixins: [
        template,
    ]
})
export class TableRowActions extends Vue {

    // Actions
    public actionsMap: Map<string, any> = new Map<string, any>([
        [
            'view',
            {
                iconName: this.$icons.EYE_GREY
            }
        ],
        [
            'edit',
            {
                iconName: this.$icons.EDIT
            }
        ],
        [
            'delete',
            {
                iconName: this.$icons.DELETE
            }
        ],

    ])

    @Prop()
    public actions!: any[]

    @Prop({type: [Object, Array]})
    public row!: object

    @Prop({type: [String, Number]})
    public rowKey!: number

    public created () {

    }
}